import React from "react";
import {
	Link
} from "react-router-dom";
import config from './../../config.js';
import Loading from './../../../components/loading.js';
import Aside from './../common/aside.js';
import Modal from './../../../components/modal.js';
import Notification from 'rc-notification';
let notification = null;
Notification.newInstance({
	style: {
		top: '45px',
		right: 0
	}
}, (n) => notification = n);

export default class CreateReportT1 extends React.Component {
	constructor(props) {
		super(props);
		//console.log(props);
		let user = {};

		if (typeof localStorage.token !== 'undefined' && localStorage.token !== '') {
			user = JSON.parse(localStorage.user);
		}

		const pagetitle = '体检报告 ';
		this.state = {
			page_title: pagetitle,
			user: user,
			projectid: props.match.params.projectid,
			taskid: props.match.params.taskid,
			tid: props.match.params.tid,
			project: '',
			creator: '',
			loading: true,
			reportlist: [],
			checkedrois: [],
			checkedtheme: 'SkyBlue',
			ismodal: false,
			reportid: 0
		}

		document.title = pagetitle;
		this.goback = this.goback.bind(this);
		this.modalClose = this.modalClose.bind(this);
		this.modalSubmit = this.modalSubmit.bind(this);
	}


	componentDidMount() {
		this.getProject();
		this.onInitial(this.props);
	}


	componentWillReceiveProps(nextProps) {
		//this.onInitial(nextProps);
	}

	notify(message) {
		notification.notice({
			content: <span>{message}</span>,
			duration: 4,
			style: {
				'bottom': 0,
				'right': 0
			}
		});
	}

	goback() { //console/myprojects/project/service_list/76/brainlabel
		const me = this;
		//me.props.history.push('/console/myprojects/project/service_list/' + me.state.projectid + '/brainlabel');
		this.props.history.goBack(1);
	}


	modalClose() {
		this.setState({
			ismodal: false,
			loading: false
		})
	}

	onInitial(data) {
		//console.log(data)
		const me = this;
		const {
			user
		} = me.state;
		const {
			projectid,
			tid
		} = data.match.params;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			brainlabelid: tid,
			request: 'list_report',
			report_type: 'report_t1',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					me.setState({
						reportlist: json.data,
						loading: false
					});

				} else {
					me.setState({
						reportlist: [],
						loading: false
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	getProject() {
		const me = this;

		let {
			projectid,
			user
		} = me.state;
		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			Authorization: localStorage.token,
			request: 'project'
		};
		fetch(config.host + '/project/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					const data = json.data;
					me.setState({
						project: data.project,
						creator: data.creator
					});
				}
			})
			.catch(function (error) {
				console.log(error);
			});
	}


	removelink(reportid) {
		const me = this;
		me.setState({
			ismodal: true,
			reportid: reportid
		});
	}

	modalSubmit() {
		const me = this;
		let {
			user,
			projectid,
			reportid,
			reportlist
		} = me.state;

		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			reportid: reportid,
			request: 'remove_report',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		me.notify('正在删除... ');
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					//window.location.href = json.data;
					let newlist = reportlist.filter((d, i) => {
						console.log(d.id)
						return d.id !== reportid;
					});
					console.log(newlist)
					me.setState({
						ismodal: false,
						reportlist: newlist
					})
				} else {
					me.notify(json.message);
				}

				me.setState({
					loading: false
				});

			})
			.catch(function (error) {
				console.log(error);
			});

	}

	downloadpdf(r) {
		const me = this;
		let {
			user,
			projectid,
			taskid,
			tid
		} = me.state;

		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			reportid: r.id,
			request: 'download_test_report',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		me.notify('即将开始下载... ');
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					//var newWin = window.open('loading pdf...');
					//newWin.location.href = json.data;
					//me.newWindow(json.data, r.id);
					me.showpdf(json.data, json.report_name);
				} else {
					me.notify(json.message);
				}

				me.setState({
					loading: false
				});

			})
			.catch(function (error) {
				console.log(error);
			});
	}

	getlink(r) {
		const me = this;
		let {
			user,
			projectid,
			taskid,
			tid
		} = me.state;

		const postdata = {
			userid: user.id,
			companyid: user.company_id,
			projectid: projectid,
			path: r.path,
			request: 'download_report',
			Authorization: localStorage.token
		};
		me.setState({
			loading: true
		});
		me.notify('即将开始下载... ');
		fetch(config.host + '/brainlabel/index', {
			method: 'post',
			body: JSON.stringify(postdata)
		})
			.then(res => res.json())
			.then(json => {
				//console.log(json);
				if (json.status === 1) {
					//window.location.href = json.data;
					me.showpdf(json.data, r.name);
				} else {

					me.notify(json.message);
				}

				me.setState({
					loading: false
				});

			})
			.catch(function (error) {
				console.log(error);
			});

	}

	showpdf(pdfurl, pdfname) {
		fetch(pdfurl).then(r => r.blob()).then(blob => {
			var newBlob = new Blob([blob], {
				type: "application/pdf"
			});

			if (window.navigator && window.navigator.msSaveOrOpenBlob) {
				window.navigator.msSaveOrOpenBlob(newBlob);
				return;
			}
			const data = window.URL.createObjectURL(newBlob);
			var link = document.createElement('a');
			link.href = data;
			link.download = pdfname;
			link.click();
			setTimeout(function () {
				window.URL.revokeObjectURL(data);
			}, 100);
		})
	}

	newWindow(url, id) {
		let a = document.createElement('a');
		a.setAttribute('href', url);
		a.setAttribute('target', '_blank');
		a.setAttribute('id', id);
		// 防止反复添加
		if (!document.getElementById(id)) {
			document.body.appendChild(a);
		}
		a.click();
	}


	render() {
		const me = this;
		const {
			creator,
			user,
			projectid,
			taskid,
			tid,
			project,
			page_title,
			reportlist
		} = me.state;

		return (

			<div className="row">
				<Loading display={me.state.loading} />
				<div className="col-10">
					<nav className="animated fadeInDown">
						<ol className="breadcrumb pb-0 px-0">
							<li className="breadcrumb-item">
								<a onClick={() => me.goback()} ><strong><i className="fa fa-chevron-left"></i> 返回全脑分割</strong></a>
							</li>
							{projectid > 0 &&
								<li className="breadcrumb-item">
									<Link className="text-dark " title="项目名称" to={`/console/myprojects/project/${projectid}/MR`}><strong> {project.name}</strong></Link>
								</li>
							}
							{projectid > 0 &&
								<li className="breadcrumb-item ">
									创建者: {creator.realname || creator.email || creator.title || creator.address || creator.office}
								</li>
							}
							<li className="breadcrumb-item active" aria-current="page">{page_title}</li>
						</ol>
					</nav>
					<table className="table table-hover bg-white">
						<thead className="thead-dark table-sm">
							<tr>
								<th className="pl-3">体检报告</th>
								<th className="pl-3">创建时间</th>
								<th className="pl-3"></th>
							</tr>
						</thead>
						<tbody>
							{
								reportlist.length > 0 && reportlist.map((r, index) => {
									let reportviewerurl = config.reportviewer + '?reportid=' + r.id + '&tid=' + r.tid + '&request=report_t1';
									return (
										<tr className="animated fadeInUp" key={index}>
											<td>{r.name}</td>
											<td>{r.date_create}</td>
											<td className="text-right">
												<a href={reportviewerurl} target="_blank" className="mr-3"> <i className="fa fa-file"></i> 查看 </a>
												<a onClick={() => me.downloadpdf(r)} className="mr-3 text-success"> <i className="fa fa-file-pdf"></i> 下载 </a>
												<a onClick={() => me.removelink(r.id)} className="text-muted"> <i className="fa fa-trash-alt"></i> 删除 </a>
											</td>
										</tr>
									)
								})
							}
						</tbody>
					</table>


					{
						!reportlist.length &&
						<div className=" text-center">
							<p className="py-3">没有创建任何报告。<Link to={`/console/t1/test_report/${projectid}/${taskid}/${tid}`}><i className="fa fa-solar-panel"></i> 去创建报告</Link></p>
						</div>
					}
					<Modal title='提醒' display={this.state.ismodal} close={this.modalClose} submit={this.modalSubmit}>
						<div>
							确定要删除？
					</div>
					</Modal>
				</div>
				<div className="col-2  pl-0 pr-0">
					<Aside data={me.props.match.params} />
				</div>
			</div>

		)
	}
}


// WEBPACK FOOTER //
// ./src/apps/console/t1/test_list_report.js